export function renderIcon(icon: string | React.ReactNode | undefined) {
  if (typeof icon === 'string') {
    return <img src={icon} alt="" />;
  } else {
    if (icon === undefined) {
      return icon;
    }

    return icon;
  }
}
